import styles from './cartHeaderDownloadSpeed.module.scss';
import { Icon, Surface, Txt } from '@vst/beam';
import { SpeedOutlined } from '@vst/beam-icons/icons';

type CartHeaderDownloadSpeedProps = {
  downloadSpeed: string;
  downloadUnits: string;
  downloadSpeedTranslationKey: string;
};

export const CartHeaderDownloadSpeed = ({
  downloadSpeed,
  downloadUnits,
  downloadSpeedTranslationKey,
}: CartHeaderDownloadSpeedProps) => {
  return (
    <Surface className={styles['downloadSpeedContainer']} data-testid="downloadSpeedContainer">
      <Icon icon={SpeedOutlined} mr="8px" color="gray_600" data-testid="downloadSpeedIcon" />
      <Txt variant="smallBold" data-testid="downloadSpeedValue" className={styles['padding']}>
        {downloadSpeed}
      </Txt>
      <Txt variant="smallBold" className={styles['padding']} data-testid="downloadSpeedUnits">
        {downloadUnits}
      </Txt>
      <Txt variant="smallRegular" data-testid="downloadSpeedText">
        {downloadSpeedTranslationKey}
      </Txt>
    </Surface>
  );
};
